const languages = require('./languages.json');
const supportedLanguageCodes = require('./mlkitSupportedLanguageCodes.json');
const _ = require('lodash');
const fs = require('fs-extra');
const path = require('path');
const obj = _.keyBy(languages, 'code');

function main() {
  const result = [];
  for (const [code, name] of Object.entries(supportedLanguageCodes)) {
    if (obj[code]) {
      result.push(obj[code]);
    }
  }

  result.sort((l, r) => {
    if (l.name > r.name) return 1;
    if (l.name < r.name) return -1;
    return 0;
  });
  fs.writeJSONSync(
    path.join(__dirname, 'mlkitSupportedLanguages.json'),
    result
  );
}

main();
